/*
 * Copyright (c) Fing Ltd. All rights reserved.
 */

import React, {Component} from 'react';

import {getLinkForSignIn, UserContext} from "../UserContext";
import intl from "react-intl-universal";
import AccountSignIn from "../assets/svg/stories/account-sign-in.svg";

export default class AccountSignedOutEmptyState extends Component {

    static contextType = UserContext;

    render() {
        return (
            <div className="container space-2">
                <div className="row justify-content-md-between align-items-md-center mb-10">
                    <div className="col-col-md-7 col-xl-6">
                        <div className="mb-6">
                            <h1 className="display-5 mb-3">Sign into your account</h1>
                            <p className="lead mb-9">Start by signing in or signing up for a free Fing account.<br/>The full potential of the Fing Suite awaits you.</p>
                        </div>
                        <div>
                            <a className="btn btn-primary btn-wide mr-lg-4"
                               href={getLinkForSignIn(this.context, window.location.href)}>{intl.get('account_sign_in')}</a>
                        </div>
                    </div>
                    <div className="col-md-5 col-xl-6">
                        <img className="img-fluid" src={AccountSignIn}
                             alt="Image Description" />
                    </div>

                </div>
            </div>
        );
    }

}
